import marioCv from "../assets/MarioNassarCV.pdf";

export const SITE = {
  name: "Mario Nassar",
  role: "Developer & Designer",
  tagline:
    "Passionate developer dedicated to crafting exceptional digital solutions with innovative and creative approaches that push boundaries.",
  email: "marionassar57@gmail.com",
  whatsapp: "+96181389885",
  whatsappDisplay: "+961 81 389 885",
  whatsappHref: "https://wa.me/96181389885",
  location: "Lebanon · Remote worldwide",
  responseTime: "Within 24 hours",
  portfolioUrl: marioCv,
  cvFileName: "Mario_Nassar_CV.pdf",
  homeUrl: "/",
  roles: ["Mobile Developer", "Web Developer"],
  availability: "Available for work",
};
